(() => {
  if (window.MinsenziaGallery2) return;
  const instances = new Map();
  const init = () => document.querySelectorAll('[data-ms-gallery-shell]').forEach(shell => {
    if (instances.has(shell)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const gallery = shell.querySelector('[data-ms-gallery]');
    const stage = shell.querySelector('[data-ms-gallery-stage]');
    const media = [...stage.querySelectorAll('[data-ms-media]')];
    const thumbs = [...shell.querySelectorAll('[data-ms-thumb]')];
    const lightbox = shell.querySelector('[data-ms-lightbox]');
    const lbImage = lightbox.querySelector('[data-ms-lightbox-img]');
    const lbStage = lightbox.querySelector('[data-ms-lightbox-stage]');
    const closeButton = lightbox.querySelector('[data-ms-lightbox-close]');
    let active = 0, zoom = 1, pan = { x: 0, y: 0 }, dragging = null, previousFocus, previousOverflow, swiped = false, loopSync = () => {};
    const applyZoom = () => {
      lbImage.style.transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
      lightbox.querySelector('[data-ms-zoom-level]').textContent = `${Math.round(zoom * 100)}%`;
      lbStage.style.cursor = zoom > 1 ? (dragging ? 'grabbing' : 'grab') : 'default';
    };
    const select = index => {
      const step = index < active ? -1 : 1;
      active = (index + media.length) % media.length;
      if (!lightbox.hidden && media[active].dataset.type === 'video') active = (active + step + media.length) % media.length;
      const selected = media[active];
      if (selected.dataset.src) {
        selected.loading = 'eager';
        selected.srcset = selected.dataset.srcset;
        selected.src = selected.dataset.src;
        delete selected.dataset.srcset;
        delete selected.dataset.src;
      }
      media.forEach((item, i) => {
        item.classList.toggle('is-active', i === active);
        item.setAttribute('aria-hidden', String(i !== active));
        if (item.tagName === 'VIDEO') {
          item.tabIndex = i === active && item.dataset.loop === undefined ? 0 : -1;
          if (i !== active) item.pause();
        }
      });
      thumbs.forEach((button, i) => { button.classList.toggle('is-active', i === active); button.setAttribute('aria-pressed', String(i === active)); });
      shell.querySelectorAll('[data-ms-gallery-counter], [data-ms-lightbox-counter]').forEach(item => { item.textContent = `${active + 1} / ${media.length}`; });
      if (!lightbox.hidden) { lbImage.src = media[active].dataset.full || media[active].currentSrc || media[active].src; lbImage.alt = media[active].alt; zoom = 1; pan = { x: 0, y: 0 }; applyZoom(); }
      loopSync();
    };
    const open = () => {
      if (media[active].dataset.type !== 'image') return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      select(active);
      closeButton.focus();
    };
    const close = () => {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.style.overflow = previousOverflow || '';
      (previousFocus?.isConnected ? previousFocus : stage).focus();
    };
    thumbs.forEach((button, index) => button.addEventListener('click', () => select(index), { signal }));
    shell.querySelectorAll('[data-ms-gallery-prev]').forEach(button => button.addEventListener('click', () => select(active - 1), { signal }));
    shell.querySelectorAll('[data-ms-gallery-next]').forEach(button => button.addEventListener('click', () => select(active + 1), { signal }));
    stage.addEventListener('click', event => { if (swiped) { swiped = false; return; } if (event.target.matches('img[data-ms-media]')) open(); }, { signal });
    gallery.addEventListener('keydown', event => {
      if (event.target.tagName === 'VIDEO') return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(active + 1); }
      if (event.target === stage && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); open(); }
    }, { signal });
    closeButton.addEventListener('click', close, { signal });
    lightbox.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.stopPropagation(); close(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(active + 1); }
      if (event.key === 'Tab') {
        const buttons = [...lightbox.querySelectorAll('button')];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }, { signal });
    lightbox.querySelectorAll('[data-ms-zoom]').forEach(button => button.addEventListener('click', () => {
      zoom = Math.max(1, Math.min(3, zoom + Number(button.dataset.msZoom)));
      if (zoom === 1) pan = { x: 0, y: 0 };
      applyZoom();
    }, { signal }));
    const swipe = target => {
      let start;
      target.addEventListener('touchstart', event => { start = event.touches.length === 1 && (target !== lbStage || zoom === 1) ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; }, { passive: true, signal });
      target.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x, dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; select(active + (dx < 0 ? 1 : -1)); }
        start = null;
      }, { passive: true, signal });
    };
    swipe(stage); swipe(lbStage);
    lbStage.addEventListener('pointerdown', event => {
      if (zoom <= 1) return;
      event.preventDefault();
      dragging = { x: event.clientX, y: event.clientY, panX: pan.x, panY: pan.y };
      lbStage.setPointerCapture(event.pointerId);
      applyZoom();
    }, { signal });
    lbStage.addEventListener('pointermove', event => {
      if (!dragging) return;
      const limit = (zoom - 1) * 250;
      pan = { x: Math.max(-limit, Math.min(limit, dragging.panX + event.clientX - dragging.x)), y: Math.max(-limit, Math.min(limit, dragging.panY + event.clientY - dragging.y)) };
      applyZoom();
    }, { signal });
    const stopDrag = () => { dragging = null; applyZoom(); };
    lbStage.addEventListener('pointerup', stopDrag, { signal });
    lbStage.addEventListener('pointercancel', stopDrag, { signal });
    const loopVideo = media.find(item => item.dataset.loop !== undefined);
    const loopToggle = shell.querySelector('[data-ms-loop-toggle]');
    if (loopVideo && loopToggle) {
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let inView = false, intent = '';
      const reflect = () => {
        const playing = !loopVideo.paused && !loopVideo.ended;
        loopToggle.dataset.playing = String(playing);
        loopToggle.setAttribute('aria-label', playing ? loopToggle.dataset.labelPause : loopToggle.dataset.labelPlay);
      };
      loopSync = () => {
        const shown = media[active] === loopVideo;
        loopToggle.hidden = !shown;
        const wants = shown && inView && !document.hidden && intent !== 'pause' && (intent === 'play' || !motion.matches);
        if (!wants) loopVideo.pause();
        else if (loopVideo.paused) loopVideo.play().then(reflect, reflect);
        reflect();
      };
      loopToggle.addEventListener('click', () => { intent = loopVideo.paused ? 'play' : 'pause'; loopSync(); }, { signal });
      ['play', 'pause', 'ended', 'error'].forEach(name => loopVideo.addEventListener(name, reflect, { signal }));
      document.addEventListener('visibilitychange', () => loopSync(), { signal });
      motion.addEventListener('change', () => { if (motion.matches) intent = ''; loopSync(); }, { signal });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; loopSync(); }, { threshold: 0.25 });
        observer.observe(stage);
        signal.addEventListener('abort', () => observer.disconnect());
      }
      signal.addEventListener('abort', () => loopVideo.pause());
    }
    select(0);
    instances.set(shell, () => { close(); controller.abort(); });
  });
  window.MinsenziaGallery2 = { init };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => instances.forEach((cleanup, shell) => { if (event.target.contains(shell)) { cleanup(); instances.delete(shell); } }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
